import { isCanvas } from '@common/utils';
import React from 'react';
import { PlayerCanvas } from './components/PlayerCanvas';
import { PlayerPreview } from './components/PlayerPreview';

const AudioPlayer = (props: any) => {
  const _isCanvas = isCanvas();

  if (_isCanvas) {
    return <PlayerCanvas {...props} />;
  }
  return <PlayerPreview {...props} />;
};

export default AudioPlayer;
